// extracted by mini-css-extract-plugin
export default {"page":"login_notMobile_page__HPYV8"};